interface Props {
  total: number;
  balance: number;
}

const PaymentTotal = ({ total, balance }: Props) => {
  const remaining = Math.max(balance - total, 0);
  const isValid = total > 0;
  const isExceeded = total > balance;

  return (
    <div className="mt-4 rounded-xl border border-success/20 bg-success/5 p-4">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-graydark dark:text-gray-400">
            Saldo pendiente
          </span>

          <span className="text-base font-medium text-black dark:text-white">
            ${balance.toFixed(2)}
          </span>
        </div>

        {/* 🔹 Total a cobrar */}
        <div className="flex items-center justify-between border-t border-success/20 pt-3">
          <span className="text-sm font-medium text-black dark:text-white">
            Total a cobrar
          </span>

          <span
            className={`text-2xl font-bold ${
              isValid ? "text-success" : "text-graydark dark:text-gray-500"
            }`}
          >
            ${total.toFixed(2)}
          </span>
        </div>

        {/* 🔹 Restante */}
        <div className="flex items-center justify-between">
          <span className="text-sm text-graydark dark:text-gray-400">
            Restante después del cobro
          </span>

          <span className="text-sm font-semibold text-black dark:text-white">
            ${remaining.toFixed(2)}
          </span>
        </div>

        {/* 🔥 Feedback */}
        {!isValid && (
          <p className="text-xs text-danger">
            Ingresa un monto para continuar
          </p>
        )}

        {isExceeded && (
          <p className="text-xs text-danger">
            El monto ingresado excede el saldo pendiente
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentTotal;